import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PROJECT} from '../../constants';

export default {
  id: 'ADD_TO_OPER',
  title: 'Wie fügt man eine Organisation zu einem Projekt hinzu?',
  description: '',
  categories: [CONTENT_CATEGORY_PROJECT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Klicken Sie auf die Registerkarte "Projekte".'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_ADD_TO_OPER/DE_ADD_TO_OPER_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Klicken Sie auf das Projekt Ihrer Wahl'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_ADD_TO_OPER/DE_ADD_TO_OPER_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Klicken Sie auf "Firma hinzufügen" in der rechten oberen Ecke'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_ADD_TO_OPER/DE_ADD_TO_OPER_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Wählen Sie die Rolle der Organisation aus'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_ADD_TO_OPER/DE_ADD_TO_OPER_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '5.',
    value: 'Geben Sie die Betriebsnummer oder den Organisationsnamen ein'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '6.',
    value: 'Wenn die Organisation auf der Plattform vorhanden ist:'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Klicken Sie auf die Organisation'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_ADD_TO_OPER/DE_ADD_TO_OPER_5.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Bestätigen Sie dann, um sie zu Ihrem Projekt hinzuzufügen'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_ADD_TO_OPER/DE_ADD_TO_OPER_6.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '7.',
    value: 'Wenn sie nicht auf der Plattform vorhanden ist :'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Klicken Sie auf die Schaltfläche "Firma "name" in mein Netzwerk einladen"'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_ADD_TO_OPER/DE_ADD_TO_OPER_7.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Füllen Sie die Details der Organisation aus'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_ADD_TO_OPER/DE_ADD_TO_OPER_8.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Klicken Sie auf Weiter'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_ADD_TO_OPER/DE_ADD_TO_OPER_9.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Und bestätigen Sie'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_ADD_TO_OPER/DE_ADD_TO_OPER_10.png`
  }]
};
